"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);

/** Loads the org's STOP-line setting and saves changes to it. Admin-only. */
 const useOrgSMSStopLine = (orgKey) => {
  const [setting, setSetting] = _react.useState(null)

  const load = _react.useCallback.call(void 0, 
    () => _actions2.default.getOrgSMSStopLine({ OrgKey: orgKey }).then(setSetting),
    [orgKey],
  )
  const hasLoadFailed = _useEntityPreload2.default.call(void 0, load)

  const save = _react.useCallback.call(void 0, 
    (enabled, text) =>
      _actions2.default.updateOrgSMSStopLine({ OrgKey: orgKey, Enabled: enabled, Text: text })
        .then(setSetting),
    [orgKey],
  )

  return { setting, hasLoadFailed, save }
}; exports.useOrgSMSStopLine = useOrgSMSStopLine
